import React from "react";
import RateModal from "../RateModal/index";
import "./index.less";
var Modal = function Modal(_ref) {
  var appKey = _ref.appKey,
    router = _ref.router;
  return /*#__PURE__*/React.createElement("div", {
    className: "nps_wrapper"
  }, /*#__PURE__*/React.createElement(RateModal, {
    appKey: appKey,
    router: router
  }));
};
export default Modal;